<div v-if="hasValidType" :class="['tt-o-hint', 'tt-o-hint--' + type]" class="tt-u-spacing--left--xs">
  <tt-icon :name="iconName" class="tt-o-hint__icon" size="xs"></tt-icon>
  <span class="tt-o-hint__text" v-html="text"></span>
  <slot></slot>
</div>
 